import {ApiGetRaw, ApiPatch, ApiPostRaw} from "../../../shared/services/api-service";
import testTemplateCommitTypes from "./commit-types";

export default {
  fetchTestTemplates() {
    return (dispatch) => {
      return ApiGetRaw('/api/v1/test-template')
        .then(data => {
          console.log(data);
          dispatch({
            type: testTemplateCommitTypes.SET_TEST_TEMPLATES,
            list: data
          })
        })
    }
  },
  fetchTestTemplateReports(testTemplateId) {
    return (dispatch) => {
      return ApiGetRaw(`/api/v1/test-template/stats/by_template/${testTemplateId}`)
        .then(data => {
          dispatch({
            type: testTemplateCommitTypes.SET_TEST_TEMPLATE_REPORTS,
            testReports: data,
            testTemplateId: testTemplateId
          })
        })
    }
  },
  createTestTemplates: function (form) {
    return (dispatch) => {
      const {shuffle_questions, ...testTemplate} = form;
      const settings = form.settings || {};

      return ApiPostRaw('/api/v1/test-template', {
        test_template: {
          ...testTemplate,
          passing_score: parseInt(form.passing_score),
          questions_displayed: parseInt(form.questions_displayed),
          settings: {
            ...settings,
            objective: form.objective === undefined ? settings.objective : parseInt(form.objective),
            subjective: form.subjective === undefined ? settings.subjective : parseInt(form.subjective),
            shuffle_questions: shuffle_questions === undefined
              ? settings.shuffle_questions !== false
              : shuffle_questions !== false
          }
        }
      })
        .then(data => {
          dispatch({
            type: testTemplateCommitTypes.PUSH_TEST_TEMPLATE,
            tt: data
          })
        })
    }
  },
  updateTestTemplates(form) {
    return (dispatch) => {
      const {shuffle_questions, ...testTemplate} = form;
      const settings = form.settings || {};

      return ApiPatch(`/api/v1/test-template/${form.id}`, {
        test_template: {
          ...testTemplate,
          passing_score: parseInt(form.passing_score),
          questions_displayed: parseInt(form.questions_displayed),
          settings: {
            ...settings,
            objective: form.objective === undefined ? settings.objective : parseInt(form.objective),
            subjective: form.subjective === undefined ? settings.subjective : parseInt(form.subjective),
            shuffle_questions: shuffle_questions === undefined
              ? settings.shuffle_questions !== false
              : shuffle_questions !== false
          }
        }
      })
        .then(data => {
          dispatch({
            type: testTemplateCommitTypes.UPDATE_TEST_TEMPLATE,
            tt: data
          })
        })
    }
  }
}
